import { Injectable } from '@angular/core';
import { Repository } from '@frontend-site/shared/utils';
import { MyItemsState } from './my-items-state';
import { createStore, select, withProps } from '@ngneat/elf';

function createInitialState(): MyItemsState {
    return {
        myItems: {
            myCorrections: 0,
            myTests: 0,
            myDefects: 0,
            myDevIssues: 0
        },
        intervalId: 0
    };
}

export interface MyItems {
    myTests: number;
    myCorrections: number;
    myDefects: number;
    myDevIssues: number;
}

@Injectable()
export class MyItemsStore extends Repository<MyItemsState> {
    readonly intervalId$ = this.store.pipe(select((state) => state.intervalId));
    readonly myItems$ = this.store.pipe(select((state) => state.myItems));

    constructor() {
        super(createStore({ name: 'MyItemsStore' }, withProps<MyItemsState>(createInitialState())));
    }

    setIntervalId(intervalId: number): void {
        this.update({ intervalId });
    }

    setMyItems(myItems: MyItems): void {
        this.update({ myItems });
    }

    get intervalId(): number {
        return this.getValue().intervalId || 0;
    }

    get myItems(): MyItems {
        return this.getValue().myItems;
    }
}
